import { Icon } from 'ol/style';
import RImage from './RImage';
/**
 * An icon
 *
 * Requires an `RStyle` context
 */
class RIcon extends RImage {
    create(props) {
        this.classProps = RIcon.classProps;
        return new Icon(props);
    }
}
RIcon.classProps = RImage.classProps.concat([
    'anchor',
    'anchorXUnits',
    'anchorYUnits',
    'color',
    'crossOrigin',
    'img',
    'offset',
    'offsetOrigin',
    'size',
    'imgSize',
    'src'
]);
export default RIcon;
//# sourceMappingURL=RIcon.js.map